import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, PRICE_BEFORE } from '../data/matematik';
const recap = ['6 bind', '5 bonusser', '240 sider', '1.–6. klasse'];
const reassurances = ['Øjeblikkelig digital adgang', 'PDF-filer klar til print', '7 dages tilfredshedsgaranti'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-112" data-mp="15fgiomwgp71z">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-rose-300 sm:left-8 lg:left-12" data-id="element-113" data-mp="1jb20oa4a2qkw" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-114" data-mp="1t2okuvylfzzs">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-115" data-mp="1t256tqc2dvr1">
          Din billedkunst kan være <em className="text-rose-600" data-id="element-116" data-mp="223d0tw7jsafb">færdigplanlagt allerede i dag.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-117" data-mp="1x4jmk1kfsfe3">
          I stedet for at lede efter idéer på nettet, lave hvert eneste elevark selv og bruge søndag aften
          på planlægning, har du en klar pakke til hele skoleåret. Mere tid til det, der virkelig
          betyder noget:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-118" data-mp="x3iqdji589c4">
          Dine elever. Din undervisning. Dit liv uden for skolen.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-119" data-mp="164goxm9tbonb">
          {recap.map(item => <li key={item} data-id="element-120" data-mp="1b2i4vybxz7uk">{item}</li>)}
        </ul>

        <p className="mt-8 text-lg text-slate-900/60" data-id="element-121" data-mp="1b171hzmes23z">Før <s data-id="element-122" data-mp="1fvb9mm7eug6n">{PRICE_BEFORE}</s></p>
        <p className="mt-2 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1fwcx5q5m4v59">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1kv7cgi4dg1km">Engangsbetaling – intet abonnement.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1pqmod4itjnee">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1tv2sb08vgkqz" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="3qufgxynvg0wd">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="3lwneiaplowdx">
              <CheckIcon className="h-4 w-4 text-rose-600" aria-hidden="true" data-id="element-129" data-mp="3hl8pgbcmugu" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}